export default "__VITE_ASSET__188c0a7c__"